import { expVal } from '@confluence/feature-experiments';

import { LicensedProductsQuery } from './LicensedProductsQuery.graphql';
import { GetLicensedProductsQuery } from './GetLicensedProductsQuery.graphql';

export const getLicensedProductsQuery = () => {
	return expVal('confluence_consolidate_licensed_product_queries', 'isEnabled', false)
		? GetLicensedProductsQuery
		: LicensedProductsQuery;
};
